module.exports = "<p>\n  mts works!\n</p>\n"